module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shared-pluviometric-chart"
  }, [_c('header', {
    staticClass: "shared-toolbar"
  }, [_c('a', {
    attrs: {
      "href": "https://info.ponceag.com/auditorias",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shared-toolbar__logo",
    attrs: {
      "src": require('../../assets/logo_black.png'),
      "alt": "PONCE",
      "width": "110"
    }
  })]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": true,
      "offset-y": "",
      "right": "",
      "nudge-bottom": "20",
      "content-class": "hamburger-menu-content",
      "transition": "scale-transition",
      "origin": "top right"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "shared-toolbar__menu-btn",
          attrs: {
            "icon": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)]
      }
    }]),
    model: {
      value: (_vm.hamburgerMenuOpen),
      callback: function($$v) {
        _vm.hamburgerMenuOpen = $$v
      },
      expression: "hamburgerMenuOpen"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "hamburger-overlay"
  }, [_c('v-btn', {
    staticClass: "hamburger-overlay__item",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.openAboutAudits
    }
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": require('../../assets/logoPonce.png'),
      "alt": "PONCE",
      "width": "24"
    }
  }), _vm._v("\n          Sobre PONCE Auditorías\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "hamburger-overlay__item",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.openAboutMonitoring
    }
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": require('../../assets/logoPonce.png'),
      "alt": "PONCE",
      "width": "24"
    }
  }), _vm._v("\n          Sobre PONCE Monitoreo\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "hamburger-overlay__item",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.openContactSupport
    }
  }, [_c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "left": "",
      "color": "#0098E1"
    }
  }, [_vm._v("mdi-whatsapp")]), _vm._v("\n          Contactar a soporte\n        ")], 1)], 1)])], 1), _vm._v(" "), _c('v-overlay', {
    attrs: {
      "value": _vm.hamburgerMenuOpen,
      "opacity": 0.35,
      "z-index": 8
    },
    nativeOn: {
      "click": function($event) {
        _vm.hamburgerMenuOpen = false
      }
    }
  }), _vm._v(" "), (_vm.pluviometricChartData && _vm.pluviometricChartData.file && _vm.pluviometricChartData.file.url) ? _c('div', {
    staticClass: "shared-viewer-panel"
  }, [_c('div', {
    staticClass: "shared-viewer-area"
  }, [_c('PdfViewer', {
    attrs: {
      "pdf-url": _vm.pluviometricChartData.file.url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "viewer-actions"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": true,
      "offset-y": "",
      "left": "",
      "nudge-left": "8",
      "content-class": "shared-viewer-actions-menu",
      "transition": "scale-transition",
      "origin": "top right"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "viewer-actions__dots-btn",
          attrs: {
            "icon": "",
            "color": "black"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)]
      }
    }], null, false, 3152868569),
    model: {
      value: (_vm.threeDotsMenuOpen),
      callback: function($$v) {
        _vm.threeDotsMenuOpen = $$v
      },
      expression: "threeDotsMenuOpen"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "shared-viewer-actions-list"
  }, [_c('v-btn', {
    staticClass: "shared-viewer-actions-list__btn",
    attrs: {
      "text": "",
      "block": "",
      "small": ""
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-download")]), _vm._v("\n              Descargar\n            ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "shared-viewer-actions-list__btn",
    attrs: {
      "text": "",
      "block": "",
      "small": ""
    },
    on: {
      "click": _vm.shareChart
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-share")]), _vm._v("\n              Compartir\n            ")], 1)], 1)])], 1), _vm._v(" "), _c('v-overlay', {
    attrs: {
      "value": _vm.threeDotsMenuOpen,
      "opacity": 0.35,
      "absolute": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.threeDotsMenuOpen = false
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.pluviometricChartId) ? _c('div', {
    staticClass: "shared-no-data"
  }, [_c('p', [_vm._v("No se encontró la carta pluviométrica.")])]) : (_vm.$apollo.queries.pluviometricChartData.loading) ? _c('div', {
    staticClass: "shared-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.pluviometricChartId && !_vm.pluviometricChartData) ? _c('div', {
    staticClass: "shared-no-data"
  }, [_c('p', [_vm._v("No se encontró la carta pluviométrica o no está publicada.")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-670fc750","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/SharedPluviometricChart.vue
// module id = 1722
// module chunks = 0